<div class="chart-details">
  {{#if source}}
    <p class="small">Source: {{{source}}}</p>
  {{/if}}
  {{#if notes}}
    <p class="small">Notes: {{{notes}}}</p>
  {{/if}}
</div>
<div class="chart-context">
  {{{context}}}
</div>
